import { FC } from 'react';
import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components';

import IconTile, { IconTileProps } from 'common/components/IconTile/IconTile';

export type Tile = {
  id: string;
  icon: Field<string>;
  title: Field<string>;
  subtitle: Field<string>;
  body: Field<string>;
  linkPath: Field<string>;
  linkTitle: Field<string>;
};

export type IconTilesProps = {
  fields: {
    items: Tile[];
  };
} & ComponentProps;

const IconTiles: FC<IconTilesProps> = ({ fields }) => {
  const tileItems = fields?.items;
  if (!tileItems?.length) return null;

  return (
    <div className="flex flex-col flex-wrap justify-center max-lg:container-fluid lg:container lg:flex-row lg:gap-x-6 lg:gap-y-20 xl:gap-x-10">
      {tileItems.map(({ id, icon, title, subtitle, body, linkPath, linkTitle }) => (
        <IconTile
          key={id}
          className="container flex-1 even:bg-gray-50 lg:m-0 lg:min-w-80 lg:max-w-96 lg:even:bg-white"
          iconName={icon?.value?.trim() as IconTileProps['iconName']}
          title={title?.value}
          subtitle={subtitle?.value}
          htmlContent={body?.value}
          link={{
            text: linkTitle?.value,
            title: linkTitle?.value,
            href: linkPath?.value,
            target: '_self',
          }}
        />
      ))}
    </div>
  );
};

export default withDatasourceCheck()<IconTilesProps>(IconTiles);
